import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { Helmet } from "react-helmet";
import MetaTags from 'react-meta-tags';
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import Loading from "../../components/Loading/Loading";
import VotingOpenHeader from "../../components/VotingOpenHeader/VotingOpenHeader";
import FilterableVideoList from "../../components/FilterableVideoList/FilterableVideoList";
import Video from "../../components/Video/Video";
import ShareLinks from "../../components/ShareLinks/ShareLinks";
import { withFirebase } from "../../components/Firebase/Firebase";
import ErrorPage from "../ErrorPage/ErrorPage";
import {defaultMetaImage, defaultMetaImageHeight, defaultMetaImageWidth} from "../../config";

class VideoPage extends Component {
  constructor(props) {
    super(props);
    this.allEntries = React.createRef();
  }
  
  handleClickEntries = () => {
    const myDomNode = ReactDOM.findDOMNode(this.allEntries.current)
    myDomNode.scrollIntoView()
	}

	getYoutubeVideoId = (url) => {
  	if (!url) {
  		return null
		}

    let newval = ''

    if (newval = url.match(/(\?|&)v=([^&#]+)/)) {
      return newval.pop()
    } else if (newval = url.match(/(\.be\/)+([^\/]+)/)) {
      return newval.pop()
    } else if (newval = url.match(/(\embed\/)+([^\/]+)/)) {
      return newval.pop().replace('?rel=0','')
    }

		return null
  }

	render() {
		const videos = this.props.competitions[this.props.competitionId].videos;
		const video = videos[this.props.videoId];
		const votingOpen = this.props.competitions[this.props.competitionId].state === "voting";
		const youtubeId = this.getYoutubeVideoId(video && video.file);
		const youtubeImg = youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : null

		return (
			<div className="container">
				<MetaTags>
					<meta property="og:type" content="website" />
					<meta property="og:title" content={`${video.title}`} />
					<meta property="og:url" content={`${window.location.href}`} />
					<meta property="og:image" content={`${youtubeImg || defaultMetaImage}`} />
					<meta property="og:image:width" content={youtubeImg ? 1280 : defaultMetaImageWidth} />
					<meta property="og:image:height" content={youtubeImg ? 720 : defaultMetaImageHeight} />
					<meta property="og:description" content="To vote, register first! This will allow you to select your favourites. Once you’re done, click the button at the bottom of the page to submit your votes. You can select up to 6 videos." />
					<meta property="og:site_name" content="Videos for Change" />
				</MetaTags>
			{votingOpen && (
				<VotingOpenHeader
					showText
					onViewEntries={this.handleClickEntries}
					slug={this.props.competitions[this.props.competitionId].url}
					competitionId={this.props.competitionId}
				/>
			)}
			<Video video={video} />
			<ShareLinks caption="Share this video" />
			<FilterableVideoList
				title="Finalists"
				ref={this.allEntries}
				videos={videos}
				competitionSlug={
					this.props.competitions[this.props.competitionId].url
				}
			/>
			</div>
		);
	}
}

// This is a small component to fetch the competition by slug and pass it down to the child (VideoPage)
class VideoPageWrapper extends Component {
	state = {
		id: null,
		error: false
	};
	async componentDidMount() {
		try {
			const id = await this.props.methods.getCompetitionBySlug(this.props.slug);
			this.setState({ id });
		} catch (error) {
			this.setState({
				error: true
			});
		}
	}
	render() {
		// Competition couldn't be found
		if (this.state.error) {
			return <ErrorPage />;
		}
		// We haven't finished loading the competition yet
		if (!this.state.id) {
			return <Loading />;
		}
		// If we found the competition but the video doesn't exist
		const videos = this.props.competitions[this.state.id].videos;
		const video = videos[this.props.videoId];
		if (!video) {
			return <ErrorPage />;
		}
		return (
			<PageWrapper context="video" full={true}>
			<Helmet title={`Videos for Change | ${video.name} - ${video.title}`} />
			<VideoPage {...this.props} competitionId={this.state.id} />
			</PageWrapper>
		);
	}
}

export default withFirebase(VideoPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/Video/Video.js